<template>
    <div class="setTing">
        <div class='setTing-title'>
            <span>{{ setTingObj.title }}</span>
        </div>
        <div class="setTing-content">
            <pageSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'pageSetting'"
            />
            <headerSercSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'headerSerch'"
            />
            <swiperBgSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'swiperBg'"
            />
            <newsSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'news'"
            />
            <menusSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'menus'"
            />
            <guideSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'guide'"
            />
            <imageBannerSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'imageBanner'"
            />
            <imageBannerLRSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'imageBannerLR'"
            />
            <storeSelectSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'storeSelect'"
            />
            <shopSelectSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'shopSelect'"
            />
            <promotionListSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'promotionList'"
            />
            <couponSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'coupon'"
            />
            <combinationSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'combination'"
            />
            <seckillSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'seckill'"
            />
            <goodListSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'goodList'"
            />
            <goodWaterfallSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'goodWaterfall'"
            />
            <magicCubeSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'magicCube'"
            />
            <videoViewSetting
                :setTingObj="setTingObj"
                v-if="setTingObj.name === 'videoView'"
            />
        </div>
    </div>
</template>

<script>
import bus from '@/components/common/bus';
import pageSetting from '@/components/decoration/material/pageSetting.vue';
import headerSercSetting from '@/components/decoration/material/headerSerc/headerSercSetting.vue';
import swiperBgSetting from '@/components/decoration/material/swiperBg/swiperBgSetting.vue';
import newsSetting from '@/components/decoration/material/news/newsSetting.vue';
import menusSetting from '@/components/decoration/material/menus/menusSetting.vue';
import guideSetting from '@/components/decoration/material/guide/guideSetting.vue';
import imageBannerSetting from '@/components/decoration/material/imageBanner/imageBannerSetting.vue';
import imageBannerLRSetting from '@/components/decoration/material/imageBannerLR/imageBannerSettingLR.vue'
import goodListSetting from '@/components/decoration/material/goodList/goodListSetting.vue';
import goodWaterfallSetting from '@/components/decoration/material/goodWaterfall/goodWaterfallSetting.vue';
import storeSelectSetting from '@/components/decoration/material/storeSelect/storeSelectSetting.vue';
import shopSelectSetting from '@/components/decoration/material/shopSelect/shopSelectSetting.vue';
import promotionListSetting from '@/components/decoration/material/promotionList/promotionListSetting.vue';
import couponSetting from '@/components/decoration/material/coupon/couponSetting.vue';
import combinationSetting from '@/components/decoration/material/combination/combinationSetting.vue';
import seckillSetting from '@/components/decoration/material/seckill/seckillSetting.vue';
import magicCubeSetting from '@/components/decoration/material/magicCube/magicCubeSetting.vue';
import videoViewSetting from '@/components/decoration/material/videoView/videoViewSetting.vue';

import promotionList from '@/components/decoration/data/promotionList.js';

export default {
    components: {
        pageSetting,
        headerSercSetting,
        swiperBgSetting,
        newsSetting,
        menusSetting,
        guideSetting,
        imageBannerSetting,
        imageBannerLRSetting,
        goodListSetting,
        goodWaterfallSetting,
        storeSelectSetting,
        shopSelectSetting,
        promotionListSetting,
        couponSetting,
        combinationSetting,
        seckillSetting,
        magicCubeSetting,
        videoViewSetting,
    },
    data() {
        return {
            setTingObj: {},
            tabStatus: 0
        };
    },
    created() {
        bus.$off("addSetting");
        bus.$on('addSetting', (e) => {
            this.setTingObj = JSON.parse(JSON.stringify(e));

            // 扩展字段兼容
            if(this.setTingObj.name == "promotionList"){
                this.setTingObj = {...promotionList,  ...this.setTingObj};
            }
        });
    },
    watch: {
        setTingObj: {
            handler(newVlaue) {
                this.updataRenderer(newVlaue);
            },
            deep: true
        }
    },
    methods: {
        updataRenderer(obj) {
            bus.$emit('updataRenderer', obj);
        }
    }
};
</script>

<style lang='scss'>
.setTing {
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .setTing-title {
        width: 100%;
        height: 48px;
        border-bottom: 1px solid #eee;
        font-size: 14px;
        padding-left: 24px;
        display: flex;
        align-items: center;
    }

    .setTing-content {
        padding: 10px;
        width: 100%;
        height: calc(100vh - 220px);
    }
}

.headerSerc-item {
    width: 100%;
    padding: 10px 0;
    font-size: 14px;
    border-bottom: 1px solid #eee;
}
</style>